export default __webpack_public_path__ + "images/CE.601c5af.png";